export const SaleInstantTableColumns =  [

    {id: 'picture', header: '图片', field: 'slot:imageUrl', width: '60px', default: true, disabled: true, fixed: 'left',},
    {id: 'asin', header: 'ASIN', field: 'slot:asin', minWidth: '120px', sortable: true, sortBy: 'asin', default: true, disabled: true, fixed: 'left',},// asin 父asin msku
    {id: 'asins', header: '分析', field: 'slot:asins', minWidth: '60px', default: true, disabled: true},
    {id: 'star', header: '星级', field: 'slot:star', minWidth: '60px', align: 'center', default: true},
    {id: 'reviewQuantity', header: '评论数', field: 'reviewQuantity', minWidth: '80px', align: 'center'},
    {id: 'ratingQuantity', header: '评星数', field: 'ratingQuantity', minWidth: '60px', align: 'center'},
    {id: 'brandName', header: '品牌', field: 'slot:brandName', minWidth: '120px', align: 'center'},
    {id: 'categoryName', header: '品类', field: 'slot:categoryName', minWidth: '120px', align: 'center'},
    {id: 'fulfillment', header: '配送渠道', field: 'fulfillment', minWidth: '80px', align: 'center'},
    {id: 'operationStatus', header: '运营状态', field: 'slot:operationStatus', minWidth: '100px', default: true},

    {id: 'bsr', header: '排名', field: 'slot:bsr', minWidth: '360px', default: true},

    {id: 'yourPrice', header: '原价', field: 'slot:yourPrice', minWidth: '100px', align: 'center', prefix: 'currencySymbol'},
    {id: 'salePrice', header: '优惠价', field: 'slot:salePrice', minWidth: '100px', align: 'center', prefix: 'currencySymbol'},


    // {id: 'product', header: 'slot:product', field: 'slot:product', minWidth: '330px'},
    {id: 'today', header: '今日', align: 'center', children: [
            {
                id: 'todaySaleQuantity',
                header: '销量',
                field: 'todaySaleQuantity',
                width: '85px',
                align: 'right',
                sortable: true,
                default: true,
                customName:'今日销量'
            },
            {
                id: 'todaySales',
                header: '销售额',
                field: 'todaySales',
                prefix: 'currencySymbol',
                width: '120px',
                align: 'right',
                sortable: true,
                default: true,
                customName:'今日销售额'
            },
            {
                id: 'todayPrice',
                header: '平均销售价',
                help: '销售额/销量',
                field: 'todayPrice',
                prefix: 'currencySymbol',
                width: '120px',
                align: 'right',
                sortable: true,
                default: true,
                customName:'今日平均销售价'
            },
        ]},
    {id: 'yesterday', header: '昨日', align: 'center', children: [
            {
                id: 'yesterdaySaleQuantity',
                header: '销量',
                field: 'yesterdaySaleQuantity',
                width: '85px',
                align: 'right',
                sortable: true,
                default: true,
                customName:'昨日销量'
            },
            {
                id: 'yesterdaySales',
                header: '销售额',
                field: 'yesterdaySales',
                prefix: 'currencySymbol',
                width: '120px',
                align: 'right',
                sortable: true,
                default: true,
                customName:'昨日销售额'
            },
            {
                id: 'yesterdayPrice',
                header: '平均销售价',
                help: '销售额/销量',
                field: 'yesterdayPrice',
                prefix: 'currencySymbol',
                width: '120px',
                align: 'right',
                sortable: true,
                default: true,
                customName:'昨日平均销售价'
            },
        ]},
    {id: 'lastWeek', header: '上周同日', align: 'center', children: [
            {
                id: 'lastWeekSaleQuantity',
                header: '销量',
                field: 'lastWeekSaleQuantity',
                width: '85px',
                align: 'right',
                sortable: true,
                default: true,
                customName:'上周同日销量'
            },
            {
                id: 'lastWeekSales',
                header: '销售额',
                field: 'lastWeekSales',
                prefix: 'currencySymbol',
                width: '120px',
                align: 'right',
                sortable: true,
                default: true,
                customName:'上周同日销售额'
            },
            {
                id: 'lastWeekPrice',
                header: '平均销售价',
                field: 'lastWeekPrice',
                help: '销售额/销量',
                prefix: 'currencySymbol',
                width: '120px',
                align: 'right',
                sortable: true,
                default: true,
                customName:'上周同日平均销售价'
            },
        ]},

    {id: 'avgSaleQuantity', header: '7/14/30日均销量', field: 'avgSaleQuantity', width: '160px', align: 'center', default: true},
    {id: 'refunds', header: '退款量', field: 'refunds', minWidth: '80px', align: 'center'},
    {id: 'returns', header: '退货量', field: 'returns', minWidth: '80px', align: 'center'},

    // {id: 'totalSaleQuantity', header: '总销量', field: 'totalSaleQuantity', minWidth: '80px', align: 'center'},
    // {id: ' totalSale', header: '总销售额', field: ' totalSale', minWidth: '120px', align: 'center', prefix: 'currencySymbol'},

    {id: 'salesGrossProfitRate', header: '销售毛利率', field: 'salesGrossProfitRate', minWidth: '100px', align: 'center', suffix: '%', sortable: true},
    {id: 'salesGrossProfit', header: '销售毛利', field: 'salesGrossProfit', minWidth: '100px', align: 'center', prefix: 'currencySymbol'},
    {id: 'userName', header: '销售负责人', field: 'userName', minWidth: '100px', overflowLine: 2, align: 'center'},
    {id: 'adsSpend', header: '广告花费', field: 'adsSpend', minWidth: '100px', align: 'center', prefix: 'currencySymbol', sortable: true},
    {id: 'adsImpressions', header: '广告曝光量', field: 'adsImpressions', minWidth: '80px', align: 'center'},
    {id: 'adsClicks', header: '广告点击量', field: 'adsClicks', minWidth: '80px', align: 'center'},
    {id: 'adsOrders', header: '广告订单量', field: 'adsOrders', minWidth: '100px', align: 'center', sortable: true},
    {id: 'adsSales', header: '广告销售额', field: 'adsSales', minWidth: '100px', align: 'center', prefix: 'currencySymbol'},

    {id: 'asoas', header: 'ASOAS', field: 'asoas', minWidth: '90px', align: 'center', suffix: '%', sortable: true},
    {id: 'acoas', header: 'ACOAS', field: 'acoas', minWidth: '90px', align: 'center', suffix: '%', sortable: true},
    {id: 'acos', header: 'ACOS', field: 'acos', minWidth: '80px', align: 'center', suffix: '%', sortable: true},
    {id: 'roas', header: 'ROAS', field: 'roas', minWidth: '80px', align: 'center', suffix: '%', sortable: true},

    {id: 'fbaInventoryQuantity', header: 'FBA可售', field: 'slot:fbaInventoryQuantity', minWidth: '80px', align: 'center', default: true},
    {id: 'fbaSaleableTurnover', header: 'FBA可售周转', field: 'fbaSaleableTurnover', minWidth: '100px', align: 'center'},
    {id: 'onTheWayQuantity', header: 'FBA在途量', field: 'onTheWayQuantity', minWidth: '100px', align: 'center', default: true},
    {id: 'fbmInventoryQuantity', header: 'FBM可售', field: 'slot:fbmInventoryQuantity', minWidth: '80px', align: 'center'},
    {id: 'fbmSaleableTurnover', header: 'FBM可售周转', field: 'fbmSaleableTurnover', minWidth: '100px', align: 'center'},

    {id: 'fbaUnsellableQuantity', header: '不可售量', field: 'fbaUnsellableQuantity', minWidth: '80px', align: 'center'},
    {id: 'fulfillableQuantity', header: '良品量', field: 'fulfillableQuantity', minWidth: '80px', align: 'center'},
    {id: 'unsellableQuantity', header: '次品量', field: 'unsellableQuantity', minWidth: '80px', align: 'center'},
    {id: 'waitShipmentQuantity', header: '待出运量', field: 'waitShipmentQuantity', minWidth: '80px', align: 'center'},
    {id: 'alreadyOrderQuantity', header: '已下单量', field: 'alreadyOrderQuantity', minWidth: '80px', align: 'center'},

    {id: 'unsalableQuantity', header: '滞销量', field: 'unsalableQuantity', minWidth: '80px', align: 'center'},
    {id: 'unsalableRate', header: '滞销率', field: 'unsalableRate', minWidth: '80px', align: 'center', suffix: '%'},


    // {id: 'inventoryQuantity', header: 'FBA可售库存', field: 'inventoryQuantity', width: '120px', align: 'right', sortable: true},
    // {id: 'onTheWayQuantity', header: 'FBA在途库存', field: 'onTheWayQuantity', width: '120px', align: 'right', sortable: true},
]